import { EventEmitter } from 'events'

/**
 * 事件监听类
 */
export default class BaseEvent {
    constructor() {
        this._eventEmitter = new EventEmitter()
    }

    bindAll(events) {
        for (const key in events) {
            if (events.hasOwnProperty(key)) {
                const event = events[key]
                this.on(key, event)
            }
        }
    }

    unBindAll(events) {
        for (const key in events) {
            if (events.hasOwnProperty(key)) {
                const event = events[key]
                this.off(key, event)
            }
        }
    }

    on(type, func) {
        this._eventEmitter.on(type, func)
    }

    once(type, func) {
        this._eventEmitter.once(type, func)
    }

    off(type, func) {
        if (func) {
            this._eventEmitter.removeListener(type, func)
        } else {
            this._eventEmitter.removeAllListeners(type)
        }
    }

    removeAllListeners() {
        this._eventEmitter.removeAllListeners()
    }

    fire(type, ...rest) {
        try {
            this._eventEmitter.emit(type, ...rest)
        } catch (error) {
            console.error(error)
        }
    }
}
